import './video-still-image-background.scss';
export class VideoStillImageBackgroundController {
    /* @ngInject */
    constructor(VideoProviderFactory, VideoProviderHelper, activeStreamService, Browser, globalUi, $timeout) {
        this.VideoProviderFactory = VideoProviderFactory;
        this.VideoProviderHelper = VideoProviderHelper;
        this.activeStreamService = activeStreamService;
        this.Browser = Browser;
        this.globalUi = globalUi;
        this.$timeout = $timeout;
        this.pictureUrl = null;
        this.fitMode = 'cover';
    }
    get streamId() {
        return this.activeStreamService.getCurrentStreamId();
    }
    $onChanges(changes) {
        if (this.Browser.isHandheld()) {
            return;
        }
        if (this.clearPictureTimeout) {
            this.$timeout.cancel(this.clearPictureTimeout);
        }
        if (this.VideoProviderFactory.activeProvider.isReceivingScreenSharingStream &&
            !this.globalUi.ui.pinnedStreamId) {
            return;
        }
        if (!Boolean(changes.triggerOn?.currentValue)) {
            this.clearPictureTimeout = this.$timeout(() => {
                this.pictureUrl = null;
            }, 1000);
            return;
        }
        let picture = '';
        void this.$timeout(async () => {
            if (this.streamId === 'self') {
                picture = await this.VideoProviderFactory.activeProvider.getImgData();
                this.fitMode = 'cover';
            }
            else {
                picture = `${this.VideoProviderFactory.activeProvider.getStreamImgData(this.streamId)}`;
                this.fitMode = this.VideoProviderHelper.getFitMode(this.streamId);
            }
            this.pictureUrl = picture && `url(${picture})`;
        });
    }
}
